import { render, staticRenderFns } from "./shopify-install.vue?vue&type=template&id=8ece28a0&scoped=true&"
import script from "./shopify-install.vue?vue&type=script&lang=js&"
export * from "./shopify-install.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ece28a0",
  null
  
)

export default component.exports